import script from "./UserPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserPage.vue?vue&type=script&setup=true&lang=ts"

import "./UserPage.vue?vue&type=style&index=0&id=4aab450d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aab450d"]])

export default __exports__